(function () {
  function initMarquee(section) {
    const track = section.querySelector('[data-marquee-track]');
    const inner = section.querySelector('[data-marquee-inner]');
    if (!track || !inner) return;

    // Remove stale clones (e.g. after theme editor block changes)
    track.querySelectorAll('[data-marquee-clone]').forEach(function (el) {
      el.remove();
    });

    const innerWidth = inner.scrollWidth;
    // Add enough clones so total content spans at least 2× the viewport
    const clonesNeeded = Math.max(Math.ceil((window.innerWidth * 2) / innerWidth), 1);

    for (var i = 0; i < clonesNeeded; i++) {
      const clone = inner.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-marquee-clone', '');
      track.appendChild(clone);
    }

    // Animate by exactly one set width for a seamless loop
    track.style.setProperty('--marquee-shift', innerWidth + 'px');
  }

  document.querySelectorAll('.marquee-rotating-info').forEach(initMarquee);

  // Re-init after theme editor section reload or block changes
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.marquee-rotating-info');
    if (section) initMarquee(section);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('.marquee-rotating-info');
    if (section) initMarquee(section);
  });
})();
